// Local re-declaration of src/components/utils/day-time.ts — pages-new/** cannot import
// from **/components/** (ESLint no-restricted-imports). `TimeslotProps` itself lives in
// src/types/types.ts, which isn't blocked, so that one is imported directly instead.

export interface Option {
  value: string
  label: string
}

const WEEK_DAYS: {[key: string]: string} = {
  MONDAY: 'Lunedì',
  TUESDAY: 'Martedì',
  WEDNESDAY: 'Mercoledì',
  THURSDAY: 'Giovedì',
  FRIDAY: 'Venerdì',
  SATURDAY: 'Sabato',
  SUNDAY: 'Domenica',
}

export const WEEK_DAY_OPTIONS: Option[] = Object.entries(WEEK_DAYS).map(([value, label]) => ({value, label}))

function buildTimeslots(): string[] {
  const slots: string[] = []
  for (let hour = 0; hour < 24; hour++) {
    for (const minute of [0, 15, 30, 45]) {
      slots.push(`${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`)
    }
  }
  return slots
}

export const TIMESLOT_OPTIONS: Option[] = buildTimeslots().map(timeslot => ({value: timeslot, label: timeslot}))
